import React from "react"
import { PlayerIdentity } from "components/ReviewAudit/PublicRatings"
import { Seed } from "./GroupList"
import { participantName } from "./MatchCard"
import { accountNumber, participantKey } from "../../../components/participantIdentity"
const value = input => input ?? "—"
// A qualifier by its people (participantIdentity.js): a Tenis10 child by its profileId, never by the parent's
// account its siblings share (PRD 16 LR11c).
const teamKey = (person, partner) =>
  [participantKey(person), participantKey(partner)].filter(Boolean).sort().join("/")
const Name = ({ person }) => <PlayerIdentity player={person} to={person?.id || person?._id ? `/accounts/players/${person.id || person._id}` : null} linkProps={{ target: "_blank", rel: "noopener noreferrer" }}>{participantName(person)} <Seed person={person} />{accountNumber(person) != null && ` #${accountNumber(person)}`}</PlayerIdentity>
export default function QualificationStandings({
  players = [],
  phases = [],
}) {
  if (!players.length) return null
  const assigned = new Set(
    phases
      .flat()
      .flatMap(match => [
        teamKey(match.player, match.playerPartner),
        teamKey(match.opponent, match.opponentPartner),
      ])
      .filter(Boolean)
  )
  return (
    <section
      className="main-draw-standings"
      aria-label="Qualification standings"
    >
      <h3>Qualification standings</h3>
      <p className="text-muted">
        Current qualification places follow the group results; they do not
        change the participants already placed in the final phase. Comparison
        statistics use the selected matches for qualification, which may differ
        from full group totals.
      </p>
      <div
        className="table-responsive"
        tabIndex={0}
        role="region"
        aria-label="Scroll qualification standings"
      >
        <table className="table table-sm" aria-label="Qualification standings">
          <thead>
            <tr>
              {[
                "Place",
                "Participant / group",
                "Qualification",
                "Wins",
                "Sets",
                "Games",
                "Set difference",
                "Game difference",
                "ML order",
                "Outcome",
              ].map(label => (
                <th scope="col" key={label}>
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {players.map((person, index) => (
              <tr key={index}>
                <td className="main-draw-qualification-place">
                  <span aria-label={`Qualification place ${index + 1}`}>
                    {index + 1}
                  </span>
                </td>
                <th scope="row">
                  <Name person={person} />
                  {person.partner?.userId && (
                    <div>
                      <Name person={person.partner} />
                    </div>
                  )}
                  <small>
                    Group {value(person.groupName)} · Place{" "}
                    {value(person.groupPosition)}
                  </small>
                </th>
                <td>
                  <strong>
                    {person.notEligible ? "Outside quota" : "Within quota"}
                  </strong>
                  <small>
                    {assigned.has(teamKey(person, person.partner))
                      ? "In generated phase"
                      : "Not placed"}
                  </small>
                  {person.sortingType && (
                    <small className="text-capitalize">
                      {person.sortingType} ranking
                    </small>
                  )}
                </td>
                <td>
                  {value(person.wins)}
                  <small>{value(person.victoryPercentage)}%</small>
                  <small title="Matches used for wins / real matches used for sets and games">
                    Used: {value(person.minMatches)} /{" "}
                    {value(person.effectiveMatches)}
                  </small>
                </td>
                <td>
                  {value(person.setsWon)} / {value(person.setsLost)}
                  <small>Won / lost · {value(person.setPercentage)}%</small>
                </td>
                <td>
                  {value(person.gamesWon)} / {value(person.gamesLost)}
                  <small>Won / lost · {value(person.gamePercentage)}%</small>
                </td>
                <td>
                  {value(person.absSetDiff)}
                  <small>Avg. {value(person.avgSetDiff)}</small>
                </td>
                <td>
                  {value(person.absGameDiff)}
                  <small>Avg. {value(person.avgGameDiff)}</small>
                </td>
                <td title="Main List order">ML #{value(person.competitionRank)}</td>
                <td>
                  {person.reason === "NO_SHOW"
                    ? "WO"
                    : person.reason === "ABANDONED"
                    ? "Abandoned"
                    : value(person.reason)}
                  {person.type && person.type !== "NONE" && (
                    <small>{person.type}</small>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
